import { render, staticRenderFns } from "./cragotranHistory.vue?vue&type=template&id=57f8188e&scoped=true&"
import script from "./cragotranHistory.vue?vue&type=script&lang=js&"
export * from "./cragotranHistory.vue?vue&type=script&lang=js&"
import style0 from "./cragotranHistory.vue?vue&type=style&index=0&id=57f8188e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f8188e",
  null
  
)

export default component.exports